import MarkdownWrapper from '@adv-mt/mt-markdown-wrapper/lib/ReservationTc'

export const ReservationLegalConditions = () => {
  return (
    <div className="mt-DrawerReservationInitialization-legalConditions">
      <MarkdownWrapper documentName="reservation-legal-conditions" />
    </div>
  )
}

ReservationLegalConditions.displayName = 'ReservationLegalConditions'
ReservationLegalConditions.propTypes = {}
